import { ACTIONS } from '../constants/accept-invitation';

const INITIAL_STATE = {
  success: false,
  error: null,
  loading: false,
};

export const acceptInvitation = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case ACTIONS.ACCEPT_INVITATION_START:
      return {
        ...state,
        success: false,
        error: null,
        loading: true,
      };
    case ACTIONS.ACCEPT_INVITATION_SUCCESS:
      return {
        ...state,
        success: action.payload,
        error: null,
        loading: false,
      };
    case ACTIONS.ACCEPT_INVITATION_FAILURE:
      return {
        ...state,
        success: false,
        error: action.payload,
        loading: false,
      };
    case ACTIONS.RESET_ACCEPT_INVITATION:
      return {
        ...state,
        success: false,
        error: null,
        loading: false,
      };
    default:
      return state;
  }
};
